/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { classnames } from "../../utils/text";
import Button from "../Button";
import CareCompanyScheduleCalendar from "./CareCompanyScheduleCalendar";
import CareCompanyScheduleList from "./CareCompanyScheduleList";
import CareCompanyScheduleWrite from "./CareCompanyScheduleWrite";

const CareCompanySchedule = ({ company, managerCompany }) => {

  const [activeTab, setActiveTab] = useState(0);
  const tabList = [
    { label: "목록보기", action: setActiveTab },
    { label: "달력보기", action: setActiveTab },
  ];

  const [schedule, setSchedule] = useState(null)
  const [toggle, setToggle] = useState(false)
  const [formType, setFormType] = useState("create")

  return (
    <div className="care-company-schedule">
      <div className="tab-list-wrap pb-24">
        <ul className="tab-list">
          {tabList.map((tab, idx) => (
            <li
              key={idx}
              className={classnames("tab-item", {
                active: activeTab === idx,
              })}
            >
              <a onClick={() => tab.action(idx)}>{tab.label}</a>
            </li>
          ))}
        </ul>
        <div className="button-wrap">
          <Button
            style={{ lineHeight: '16px' }}
            onClick={() => {
              setSchedule({})
              setFormType("create")
              setToggle(true)
            }}
          >작성하기</Button>
        </div>
      </div>
      <CareCompanyScheduleWrite
        company={company}
        managerCompany={managerCompany}
        schedule={schedule}
        setSchedule={setSchedule}
        toggle={toggle}
        setToggle={setToggle}
        formType={formType}
      />
      {activeTab === 0 && <CareCompanyScheduleList
        company={company}
        managerCompany={managerCompany}
        setSchedule={setSchedule}
        toggle={toggle}
        setToggle={setToggle}
        setFormType={setFormType}
      />}
      {activeTab === 1 && <CareCompanyScheduleCalendar
        company={company}
        managerCompany={managerCompany}
        setSchedule={setSchedule}
        toggle={toggle}
        setToggle={setToggle}
        setFormType={setFormType}
      />}
    </div >
  );
};


export default CareCompanySchedule;
